import React from 'react'
import Checkout from './pages/checkout/Checkout';
import Cart from './pages/cart/Cart';
import AppointmentSuccess from './pages/AppointmentSuccess';
import AppointmentCancel from './pages/AppointmentCancel';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import BuildMyPkg from './pages/BuildPackage/BuildMyPkg';
import Consultation from './pages/consultation/Consultation';
import PreviewConsultation from './pages/consultationPreview/PreviewConsultation';
import { AllBloodTest } from './pages/BloodTesting/AllBloodTest';
import { BloodTestDetail } from './pages/BloodTesting/BloodTestDetail';
import ScrollTop from './components/ScrollTop';
import { WeightLoss } from './pages/WeightLoss/WeightLoss';
import ProductSelection from './pages/ProductSelection/ProductSelection';

import ProductsGuard from './middleware/ProductGuard';
import { AllTravelClinic } from './pages/TravelClinic/AllTravelClinic';
import { TravelClinicDetail } from './pages/TravelClinic/TravelClinicDetail';
import ExistingUserPage from './pages/existingUserPage';

import PatientLogin from './pages/auth/PatientLogin';
import PatientRegister from './pages/auth/PatientRegister';
import VerifyEmail from './pages/auth/VerifyEmail';
import ForgetPassword from './pages/auth/ForgetPassword';
import ResetPassword from './pages/auth/ResetPassword';

import WlConsultation from './pages/consultation/WlConsultation';

import PrivateRoute from './routes/PrivateRoute';
import Thankyou from './pages/checkout/Thankyou';
import DirectCheckout from './pages/DirectCheckout/DirectCheckout';

import { TRConsultation as TranscribedConsultation } from './pages/TranscribedConsultation/TRConsultation';
import Transcription from './pages/TranscribedConsultation/Transcription';
import { TravelConsultation } from './pages/TravelConsultation/TravelConsultation';
import { IndividualTravelConsultation } from './pages/TravelConsultation/IndividualTravelConsultation';
import { GeneralConsultation } from './pages/generalConsultations/GeneralConsultation';
import ThankyouTranscription from './pages/TranscribedConsultation/ThankyouTranscription';
import Quizz from './pages/quiz/Quizz';
import { Survey } from './pages/survey/Survey';
import Products from './pages/generalConsultations/screens/Products';
import { TokenPrescription } from './pages/TokenPrescription/TokenPrescription';
import { TokenPrescriptionDetails } from './pages/TokenPrescriptionDetails/TokenPrescriptionDetails';
import NoIndexSeo from './components/NoIndexSeo';
import HomePage from './pages/HomePage';
import BloodTestingPage from './pages/BloodTestingPage/BloodTestingPage';
import TravelClinicPage from './pages/TravelClinicPage/TravelClinicPage';
import ContactPage from './pages/ContactPage/ContactPage';
import ComplaintsPage from './pages/ComplaintsPage/ComplaintsPage';
import SimplyBookPage from './pages/SimplyBookPage/SimplyBookPage';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';
import CookiePolicyPage from './pages/CookiePolicyPage/CookiePolicyPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage/TermsPage';
import SustainableWeightLossPage from './pages/SustainableWeightLossPage';
import ImportanceOfBloodTestingPage from './pages/ImportanceOfBloodTestingPage';

function NoIndex({ title, children }) {
  return (
    <>
      <NoIndexSeo title={title} />
      {children}
    </>
  );
}

const App = () => {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='/blood-testing' element={<BloodTestingPage />} />
        <Route path='/travel-clinic' element={<TravelClinicPage />} />
        <Route path='/contact' element={<ContactPage />} />
        <Route path='/complaints' element={<ComplaintsPage />} />
        <Route path='/your-sexual-health' element={<SimplyBookPage key="your-sexual-health" slug="your-sexual-health" title="Your Sexual Health" category="27" description="Book a confidential sexual health appointment with My Private Chemist." />} />
        <Route path='/nationwide-pathology' element={<SimplyBookPage key="nationwide-pathology" slug="nationwide-pathology" title="Nationwide Pathology" category="16" description="Book a nationwide pathology appointment with My Private Chemist." />} />
        <Route path='/better2know' element={<SimplyBookPage key="better2know" slug="better2know" title="Better2Know" category="29" description="Book a Better2Know appointment with My Private Chemist." />} />
        <Route path='/cookie-policy' element={<CookiePolicyPage />} />
        <Route path='/privacy-policy' element={<PrivacyPolicyPage />} />
        <Route path='/terms-and-conditions' element={<TermsPage />} />
        <Route path='/sustainable-weight-loss-glp-1-medications' element={<SustainableWeightLossPage />} />
        <Route path='/the-importance-of-blood-testing' element={<ImportanceOfBloodTestingPage />} />
        <Route path='/a-z-tests' element={<AllBloodTest />} />
        <Route path='/a-z-list' element={<Navigate to="/a-z-tests" replace />} />
        <Route path='/blood-tests/:slug' element={<BloodTestDetail />} />
        <Route path='/checkout' element={<NoIndex title="Checkout"><Checkout /></NoIndex>} />
        <Route path='/direct-checkout' element={<NoIndex title="Checkout"><DirectCheckout /></NoIndex>} />
        <Route path='/cart' element={<NoIndex title="Cart"><Cart /></NoIndex>} />
        <Route path="/appointment/success/:bookingId/:userToken" element={<NoIndex title="Booking confirmed"><AppointmentSuccess /></NoIndex>} />
        <Route path='/appointment/cancel' element={<NoIndex title="Appointment cancelled"><AppointmentCancel /></NoIndex>} />
        <Route path='/build-my-package' element={<BuildMyPkg />} />
        <Route path='/consultation/weight-loss' element={<NoIndex title="Weight loss consultation"><WlConsultation /></NoIndex>} />
        <Route path='/consultation/preview/:id' element={<NoIndex title="Consultation preview"><PreviewConsultation /></NoIndex>} />
        <Route path='/weight-loss' element={<WeightLoss />} />
        <Route path="/products" element={<NoIndex title="Products"><ProductsGuard><ProductSelection /></ProductsGuard></NoIndex>} />
        <Route path='/travel-clinic/vaccinations-by-diseases' element={<AllTravelClinic />} />
        <Route path='/travel-clinic/vaccinations-by-diseases/:slug' element={<TravelClinicDetail />} />
        <Route path='/consultation-weight-loss' element={<NoIndex title="Weight loss consultation"><ExistingUserPage /></NoIndex>} />
        <Route path='/login' element={<NoIndex title="Login"><PatientLogin /></NoIndex>} />
        <Route path='/signup' element={<NoIndex title="Sign up"><PatientRegister /></NoIndex>} />
        <Route path='/verify-email' element={<NoIndex title="Verify email"><VerifyEmail /></NoIndex>} />
        <Route path='/forget-password' element={<NoIndex title="Forgot password"><ForgetPassword /></NoIndex>} />
        <Route path='/reset-password/:token' element={<NoIndex title="Reset password"><ResetPassword /></NoIndex>} />
        <Route path='/wl-consultation' element={<NoIndex title="Weight loss consultation"><WlConsultation /></NoIndex>} />
        <Route path='/booking/confirmation/:id' element={<NoIndex title="Order confirmation"><Thankyou /></NoIndex>} />
        <Route path="/consultation/transcribed-consultation" element={<NoIndex title="Transcribed consultation"><TranscribedConsultation /></NoIndex>} />
        <Route path="/transcription" element={<NoIndex title="Transcription"><Transcription /></NoIndex>} />
        <Route path="/transcription/success/:id" element={<NoIndex title="Transcription submitted"><ThankyouTranscription /></NoIndex>} />
        <Route path="/travel-vaccine/assessment" element={<NoIndex title="Travel vaccine assessment"><TravelConsultation /></NoIndex>} />
        <Route path="/travel-vaccine/assessment/:refNo" element={<NoIndex title="Travel vaccine assessment"><IndividualTravelConsultation /></NoIndex>} />
        <Route
          path="/travel-vaccine-risk-assessment"
          element={<Navigate to="/travel-vaccine/assessment" replace />}
        />
        <Route path="/:id/assessment" element={<NoIndex title="Consultation assessment"><GeneralConsultation /></NoIndex>} />
        <Route path="/quiz" element={<NoIndex title="Quiz"><Quizz /></NoIndex>} />
        <Route path="/survey" element={<NoIndex title="Survey"><Survey /></NoIndex>} />
        <Route path="/prescription" element={<NoIndex title="Prescription"><TokenPrescription /></NoIndex>} />
        <Route path="/prescription/:authCode" element={<NoIndex title="Prescription"><TokenPrescriptionDetails /></NoIndex>} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes >
    </BrowserRouter >
  )
}

export default App
